// extracted by mini-css-extract-plugin
module.exports = {"form":"PaymentTechnicalSettings_form_1Dnko","submit":"PaymentTechnicalSettings_submit_1jylo"};